import { render, staticRenderFns } from "./Fanwei.vue?vue&type=template&id=797a6d86&scoped=true&"
import script from "./Fanwei.vue?vue&type=script&lang=js&"
export * from "./Fanwei.vue?vue&type=script&lang=js&"
import style0 from "./Fanwei.vue?vue&type=style&index=0&id=797a6d86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a6d86",
  null
  
)

export default component.exports